export default __webpack_public_path__ + "static/media/biriyanijpg.01de32ec.jpg";